export default __webpack_public_path__ + "static/media/jio.0d765e71.png";